import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

import ru from '@/locale/ru';
import en from '@/locale/en';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: false, // From 2.0 You have to select the theme dark or light here
  },
  icons: {
    iconfont: 'md', // default - only for display purposes
  },
    lang: {
    locales: {en, ru},
    current: localStorage.getItem('lang') || 'en',
  },
});
